import { render, staticRenderFns } from "./CondicionesParticipar.vue?vue&type=template&id=064d2b59&"
var script = {}
import style0 from "./CondicionesParticipar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports